var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreakdownFeature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 64,
    height: 64,
    rx: 19.5,
    stroke: "#19C48F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54_1311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 20.5L33.1462 20.5087C33.4253 20.5417 33.6851 20.6676 33.8837 20.8663C34.0824 21.0649 34.2083 21.3247 34.2413 21.6037L34.25 21.75V26.75L34.2563 26.9375C34.301 27.5327 34.5572 28.0923 34.9786 28.515C35.4 28.9378 35.9587 29.1958 36.5538 29.2425L36.75 29.25H41.75L41.8963 29.2587C42.1753 29.2917 42.4351 29.4176 42.6337 29.6163C42.8324 29.8149 42.9583 30.0747 42.9912 30.3538L43 30.5V41.75C43.0001 42.7065 42.6346 43.6269 41.9784 44.3228C41.3222 45.0188 40.4249 45.4376 39.47 45.4938L39.25 45.5H26.75C25.7935 45.5001 24.8731 45.1346 24.1772 44.4784C23.4812 43.8222 23.0624 42.9249 23.0063 41.97L23 41.75V24.25C22.9999 23.2935 23.3654 22.3731 24.0216 21.6772C24.6778 20.9812 25.5751 20.5624 26.53 20.5063L26.75 20.5H33Z",
    fill: "#19C48F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.75 26.75H36.75L36.7487 21.7488L41.75 26.75Z",
    fill: "#19C48F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54_1311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(18 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreakdownFeature);
export default __webpack_public_path__ + "static/media/breakdown_feature.7cfae5023a57751abdc23d1423027603.svg";
export { ForwardRef as ReactComponent };